import React from 'react';
import '../../../styles/labelling.scss';
import TickIcon from '../../../../../Icons/icons/TickIcon';
import EditPen from '../../../../../Icons/icons/EditPen';
import XIcon from '../../../../../Icons/icons/XIcon';

const LabelItem = ({ onEditClick, title, checked, color, onClick, onRemove, size = 'lg', hoverable = true }) => {
  const iconSize = size === 'sm' ? 30 : 34;

  return (
    <div className="sl-label-item-container">
      <div
        onClick={onClick}
        style={{ borderColor: checked ? 'var(--purple-p-400)' : '' }}
        className={`sl-label-item-box ${hoverable ? 'sl-label-item-box-hover' : ''}`}>
        <div className="sl-label-item-box-left-container">
          <div
            style={{ backgroundColor: color, width: size === 'sm' ? '6px' : undefined }}
            className="sl-label-left-color-box"
          />
          <div
            style={{
              padding: size === 'md' ? '10px' : size === 'sm' ? '6px' : undefined,
              fontSize: size === 'md' ? '18px' : size === 'sm' ? '12px' : undefined,
              lineHeight: size === 'sm' ? '18px' : undefined,
            }}
            className="sl-label-item-title">
            {title}
          </div>
        </div>
        {onRemove && (
          <XIcon
            style={{ cursor: 'pointer', paddingRight: '5px' }}
            color="var(--icon-default)"
            width={26}
            height={26}
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
          />
        )}
        {checked && <TickIcon width={iconSize} height={iconSize} color="var(--purple-p-400)" />}
      </div>
      {onEditClick && (
        <EditPen
          style={{ cursor: 'pointer' }}
          onClick={() => onEditClick()}
          width={20}
          height={20}
          color="var(--icon-default)"
        />
      )}
    </div>
  );
};

export default LabelItem;
